<template lang="pug">
  //- App URL de la App de Jumpseller: se muestra en un iframe dentro del admin de Jumpseller.
  .jumpseller-app
    b-container(fluid="md")
      .text-center
        img.jumpseller-app-logo(src="../assets/logos/original.png" alt="12 Horas Envíos")
      h4.text-center.mt-3 12 Horas Envíos para Jumpseller
      p
        | Transforma automáticamente tus pedidos pagados en envíos de 12 Horas Envíos y mantén informados
        | a tus clientes con el seguimiento de cada despacho directamente en Jumpseller.
      h5.mt-4 ¿Qué hace la app?
      ul
        li Cada pedido pagado con dirección de despacho en una comuna con cobertura crea un envío en 12 Horas Envíos.
        li Se agrega al pedido un despacho con el código y el enlace de seguimiento.
        li El estado del despacho (en tránsito, entregado o fallido) se actualiza automáticamente en Jumpseller.
        li Si cancelas un pedido en Jumpseller, su envío se cancela en 12 Horas Envíos.
      h5.mt-4 Cómo conectar tu tienda
      ol
        li Necesitas una cuenta de tienda en 12 Horas Envíos. Si aún no la tienes, escríbenos a
          a.ml-1(:href="`mailto:${supportEmail}`") {{ supportEmail }}
          | .
        li
          | Inicia sesión en
          a.ml-1(:href="panelUrl" target="_blank" rel="noopener") 12 Horas Envíos
          |  y ve a
          b.ml-1 Integraciones
          | .
        li Presiona "Conectar con Jumpseller" y autoriza el acceso de la app.
      .text-center.mt-4
        b-button(variant="primary" :href="panelUrl" target="_blank" rel="noopener") Ir a 12 Horas Envíos
      p.text-muted.text-center.mt-4.mb-0
        | ¿Necesitas ayuda? Escríbenos a
        a.ml-1(:href="`mailto:${supportEmail}`") {{ supportEmail }}
</template>

<script>
export default {
  data() {
    return {
      supportEmail: 'contacto@12horasenvios.com'
    }
  },
  computed: {
    panelUrl() {
      return `${window.location.origin}/integraciones`
    }
  }
}
</script>

<style lang="scss" scoped>
.jumpseller-app {
  padding: 24px 16px;
  background: #fff;
  min-height: 100vh;

  &-logo {
    height: 56px;
  }
}
</style>
